import React from "react";
import { FiFilter } from "react-icons/fi";

const KioskFilters = ({
  filters,
  onChange,
  userOptions = [],
  measurementOptions = [],
  showStatus = false,
}) => (
  <section className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm" aria-label="Filtros de KIOSK">
    <div className="flex items-center gap-2 mb-4">
      <FiFilter className="w-4 h-4 text-[#0075AC]" />
      <h2 className="text-sm font-bold text-[#1D1F3F]">Filtros</h2>
      <span className="text-xs text-slate-400">Actualización automática</span>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <label className="flex flex-col gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
        Usuario
        <select
          aria-label="Usuario"
          value={filters.usuarioId || ""}
          onChange={event => onChange("usuarioId", event.target.value || undefined)}
          className="h-10 w-full normal-case appearance-none cursor-pointer bg-white border border-slate-200 rounded-xl px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
        >
          <option value="">Todos los usuarios</option>
          {userOptions.map(option => (
            <option key={option.usuarioId} value={option.usuarioId}>
              {option.nombre || `Usuario ${option.usuarioId}`}
            </option>
          ))}
        </select>
      </label>

      <label className="flex flex-col gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
        Desde
        <input
          aria-label="Desde"
          type="date"
          value={filters.fechaDesde || ""}
          onChange={event => onChange("fechaDesde", event.target.value || undefined)}
          className="h-10 w-full bg-white border border-slate-200 rounded-xl px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
        />
      </label>

      <label className="flex flex-col gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
        Hasta
        <input
          aria-label="Hasta"
          type="date"
          value={filters.fechaHasta || ""}
          onChange={event => onChange("fechaHasta", event.target.value || undefined)}
          className="h-10 w-full bg-white border border-slate-200 rounded-xl px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
        />
      </label>

      <label className="flex flex-col gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
        Medición
        <select
          aria-label="Medición"
          value={filters.sessionId || ""}
          onChange={event => onChange("sessionId", event.target.value || undefined)}
          className="h-10 w-full normal-case appearance-none cursor-pointer bg-white border border-slate-200 rounded-xl px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
        >
          <option value="">Todas las mediciones</option>
          {measurementOptions.map(option => (
            <option key={option.sessionId} value={option.sessionId}>
              {option.fecha || "Sin fecha"} · {option.nombre || `Usuario ${option.usuarioId}`}
            </option>
          ))}
        </select>
      </label>

      {showStatus && (
        <label className="flex flex-col gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
          Estado
          <select
            aria-label="Estado"
            value={filters.status || ""}
            onChange={event => onChange("status", event.target.value || undefined)}
            className="h-10 w-full normal-case appearance-none cursor-pointer bg-white border border-slate-200 rounded-xl px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
          >
            <option value="">Todos los estados</option>
            <option value="published">Programado</option>
            <option value="in_progress">En curso</option>
            <option value="completed">Completado</option>
            <option value="cancelled">Cancelado</option>
          </select>
        </label>
      )}
    </div>
  </section>
);

export default KioskFilters;
